import { render, staticRenderFns } from "./layout-screen.vue?vue&type=template&id=3830746d&scoped=true"
import script from "./layout-screen.vue?vue&type=script&lang=js"
export * from "./layout-screen.vue?vue&type=script&lang=js"
import style0 from "./layout-screen.vue?vue&type=style&index=0&id=3830746d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_50f6069bc14464b8bd79aa1c8f71d64f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3830746d",
  null
  
)

export default component.exports